let title = "ERPSPACE";

const domain = window.location.hostname;

if (domain == "app.vseli.com" || domain == "staging.vseli.com") {
    title = "VSELI";
}

export default title;